import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { legacyUrl } from "@/config";
import { usePurgeMediaMutation } from "@/features/media/api";
import { getMediaState } from "@/features/media/slice";
import { useAppSelector } from "@/redux/hooks";

const partialMediaButtonSx = {
	px: 1.25,
	py: 0.25,
	border: "none",
	textTransform: "none",
	fontWeight: 400,
	bgcolor: "#7E7E7E",
	color: "#fff",
	boxShadow: "none",
	"&:hover": {
		bgcolor: "#6f6f6f",
		border: "none",
		boxShadow: "none",
	},
	"&:focus, &:focus-visible": {
		border: "none",
		outline: "none",
		boxShadow: "none",
	},
	"&.Mui-focusVisible": {
		border: "none",
		boxShadow: "none",
	},
};

const PartialMediaAlert = () => {
	const { partialMedia } = useAppSelector(getMediaState);
	const [purgeMedia, { isLoading }] = usePurgeMediaMutation();

	const handleResume = () => {
		window.location.assign(legacyUrl + "/AddMedia/Index");
	};

	const handlePurge = () => {
		purgeMedia(partialMedia.mediaCode);
	};

	if (!partialMedia.hasPartialMedia) return null; // render nothing.

	if (isLoading)
		return (
			<Stack direction="row" spacing={1}>
				<CircularProgress color="info" size={18} />
				<Typography variant="body2">Purging Media...</Typography>
			</Stack>
		);

	return (
		<Stack
			direction="row"
			spacing={2}
			alignItems="center"
			height={"100%"}
			py="12px"
			sx={{ minWidth: 0 }}
		>
			<Stack
				spacing={0}
				minWidth={0}
				overflow="hidden"
				flex={1}
				maxWidth="400px"
			>
				<Typography variant="body2">Partial Media Exists</Typography>
				<Typography
					variant="body2"
					fontWeight="bold"
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
				>
					{partialMedia.mediaNumber}
				</Typography>
				<Typography
					variant="body2"
					color="text.secondary"
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
				>
					{partialMedia.title}
				</Typography>
			</Stack>
			<Stack
				direction="row"
				sx={{ flexShrink: 0, whiteSpace: "nowrap", gap: 0.5 }}
			>
				<Button
					size="small"
					variant="contained"
					disableElevation
					sx={partialMediaButtonSx}
					onClick={handleResume}
				>
					Resume
				</Button>
				<Button
					size="small"
					variant="contained"
					disableElevation
					sx={partialMediaButtonSx}
					onClick={handlePurge}
				>
					Purge
				</Button>
			</Stack>
		</Stack>
	);
};

export default PartialMediaAlert;
